// Mirrors backend content.py access tiers. UI-gating only; the server is the source of truth.
export const MEMBER_PLANS = new Set([
  "insider", "certified", "featured", "shop_standard", "shop_featured",
  "vendor_entry", "vendor_premium", "educator", "client_premium",
]);
export const PREMIUM_ACCESS_PLANS = new Set(["certified", "featured", "shop_featured", "vendor_premium", "educator"]);
export const LEAD_ACCESS_PLANS = new Set(["certified", "featured"]);

function active(user, set) {
  if (!user) return false;
  if (user.role === "admin") return true;
  return set.has(user.plan) && user.plan_status === "active";
}

export const isMember = (user) => active(user, MEMBER_PLANS);
export const hasPremiumAccess = (user) => active(user, PREMIUM_ACCESS_PLANS);
export const hasLeadAccess = (user) => active(user, LEAD_ACCESS_PLANS);
